import adminUserService from '../service/adminUser'

const state = {
    adminUsers: [],
    loading: false
}

const actions = {
    getAdminUsers({ commit }) {
        commit('setLoading', true)
        return adminUserService.getAdminUsers().then(adminUsers => {
            commit('setAdminUsers', adminUsers)
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    createAdminUser({ commit }, adminUser) {
        return adminUserService.createAdminUser(adminUser).then(_id => {
            adminUser._id = _id
            commit('addAdminUser', adminUser);
        })
    },
    updateAdminUser({ commit }, adminUser) {
        return adminUserService.updateAdminUser(adminUser).then(() => {
            commit('updateAdminUser', adminUser);
        })
    },

    deleteAdminUser({ commit }, adminUserId) {
        return adminUserService.deleteAdminUser(adminUserId)
        .then(() => {
            commit('deleteAdminUser', adminUserId);
        })
    }
};
const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
    updateAdminUser(state, updatedAdminUser) {
        var adminUser = state.adminUsers.find(x => x._id == updatedAdminUser.id)
        if (adminUser) {
            adminUser.name = updatedAdminUser.name;
            adminUser.role = updatedAdminUser.role;
            adminUser.surname = updatedAdminUser.surname;
            adminUser.email = updatedAdminUser.email;
        }
    },
    addAdminUser(state, adminUser) {
        state.adminUsers.push(adminUser)
    },
    deleteAdminUser(state, adminUserId) {
        var index = state.adminUsers.findIndex(x => x._id == adminUserId)
        if (index != -1) {
            state.adminUsers.splice(index, 1)
        }
    },
    setAdminUsers(state, adminUsers) {
        state.adminUsers = adminUsers
        state.loading = false
    },

};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
